import portfolioImage1 from '../assets/portfolio/portfolio-1.png';
import portfolioImage2 from '../assets/portfolio/portfolio-2.png';
import portfolioImage3 from '../assets/portfolio/portfolio-3.png';
import portfolioImage4 from '../assets/portfolio/portfolio-4.png';
import portfolioImage5 from '../assets/portfolio/portfolio-5.png';
import portfolioImage6 from '../assets/portfolio/portfolio-6.png';
import portfolioImage7 from '../assets/portfolio/portfolio-7.png';
import portfolioImage8 from '../assets/portfolio/portfolio-8.png';
import portfolioImage9 from '../assets/portfolio/portfolio-9.png';

export const siteMeta = {
  companyName: 'LRJA Synthetic Granite Trading',
  shortCompanyName: 'LRJA',
  tagline: 'Premium Synthetic Granite Solutions',
  foundedYear: 2015,
};

export const navigationLinks = [
  { name: 'Home', href: '#home' },
  { name: 'About', href: '#about' },
  { name: 'Products', href: '#products' },
  { name: 'Projects', href: '#projects' },
  { name: 'Services', href: '#services' },
  { name: 'Contact', href: '#contact' },
];

export const stoneShowcaseContent = {
  badge: 'Stone Collection',
  title: 'Materials That Feel Architectural',
  description:
    'Inspired by premium surface brands, our curated stone gallery pairs bold veining, rich depth, and dependable performance for modern interiors.',
  slides: [
    {
      id: 1,
      name: 'Largo Vein',
      category: 'Marble-Inspired Solid Surface',
      description: 'Dual-line veining and polished contrast for statement counters and feature walls.',
      image: portfolioImage6,
      accent: 'from-[#e0d1b4] to-[#9e8157]',
    },
    {
      id: 2,
      name: 'Glacier White',
      category: 'Minimal Collection',
      description: 'Clean and timeless tone with seamless joins, ideal for hygienic high-traffic spaces.',
      image: portfolioImage5,
      accent: 'from-[#f1f1ea] to-[#bfbfb2]',
    },
    {
      id: 3,
      name: 'Midnight Grain',
      category: 'Commercial Performance',
      description: 'Deep charcoal base with natural particulate texture for premium hospitality projects.',
      image: portfolioImage8,
      accent: 'from-[#565b63] to-[#1f2329]',
    },
    {
      id: 4,
      name: 'Stonecrest Smoke',
      category: 'Contemporary Signature',
      description: 'Soft movement and tonal depth to elevate reception counters and bespoke furniture.',
      image: portfolioImage1,
      accent: 'from-[#cec8bd] to-[#787068]',
    },
  ],
};

export const productBrands = [
  'Corian',
  'Staron',
  'Montelli',
  'Himacs',
  'Polystone',
  'Solflex',
  'Flexstone',
  'Quartz',
  'And Others',
];

export const contactInfo = {
  phones: ['09175748756', '09771666458'],
  emails: ['info@lrjasgt.com', 'agot@lrjasgt.com'],
  addresses: {
    office: [
      '108 San Miguel St.',
      'San Antonio Valley 6',
      'San Isidro, Sucat',
      'Paranaque',
    ],
    extensionOffice: [
      '8893 San Pablo Street',
      'San Antonio Valley 6',
      'San Isidro, Sucat',
      'Paranaque',
    ],
  },
  businessHours: 'Monday - Saturday: 8:00 AM - 6:00 PM',
};

export const socialLinks = [];

export const heroContent = {
  badge: 'Premium Stone Solutions',
  subtitle: 'Trading',
  description:
    'Transforming spaces with exquisite synthetic granite surfaces. Crafted for elegance, built to last.',
  stats: [
    { value: '500+', label: 'Projects Done' },
    { value: '350+', label: 'Happy Clients' },
    { value: '10+', label: 'Years Experience' },
  ],
};

export const aboutContent = {
  title: 'Crafting Excellence',
  highlightedTitle: 'in Stone',
  lead:
    "LRJA Synthetic Granite Trading is a leading provider of high-quality synthetic granite products for residential and commercial applications. With years of expertise in the industry, we specialize in creating stunning, durable surfaces that transform spaces into works of art.",
  mission:
    "Our mission is to deliver exceptional synthetic granite solutions that combine beauty, durability, and value, exceeding our clients' expectations through superior craftsmanship and customer service.",
  features: [
    { icon: 'Award', title: 'Excellence', desc: 'Premium quality materials' },
    { icon: 'Shield', title: 'Durability', desc: 'Built to last decades' },
    { icon: 'Users', title: 'Expert Team', desc: 'Skilled craftsmen' },
    { icon: 'Sparkles', title: 'Custom Design', desc: 'Tailored solutions' },
  ],
};

export const servicesContent = [
  {
    icon: 'Hammer',
    title: 'Custom Fabrication',
    description:
      'Tailored granite surfaces designed to your exact specifications, from material selection to precision cutting and finishing.',
    features: ['Precise measurements', 'Custom edge profiles', 'Color matching'],
  },
  {
    icon: 'Wrench',
    title: 'Installation Services',
    description:
      'Professional installation by our team of experienced craftsmen, ensuring perfect fit and lasting quality.',
    features: ['Expert installers', 'Seamless joints', 'Quality guarantee'],
  },
  {
    icon: 'Home',
    title: 'Residential Projects',
    description:
      'Transform your home with elegant countertops, vanities, and custom surfaces that elevate everyday living.',
    features: ['Kitchen countertops', 'Bathroom vanities', 'Custom tables'],
  },
  {
    icon: 'Building2',
    title: 'Commercial Projects',
    description:
      'Large-scale solutions for offices, hotels, restaurants, and retail spaces with consistent quality.',
    features: ['Reception desks', 'Bar counters', 'Wall cladding'],
  },
];

export const whyChooseUsContent = [
  {
    icon: 'Gem',
    title: 'High-Quality Materials',
    description: 'We source only the finest synthetic granite materials, ensuring durability and consistent quality.',
  },
  {
    icon: 'Target',
    title: 'Precision Craftsmanship',
    description: 'Our skilled artisans combine traditional techniques with modern technology for flawless results.',
  },
  {
    icon: 'Headset',
    title: 'Reliable Support',
    description: 'Comprehensive warranty and maintenance guidance for lasting satisfaction.',
  },
  {
    icon: 'BadgePercent',
    title: 'Competitive Pricing',
    description: 'Premium quality at fair prices with transparent pricing and no hidden costs.',
  },
];

export const testimonialContent = [
  {
    name: 'Maria Santos',
    role: 'Homeowner, Makati',
    content:
      'LRJA transformed our kitchen completely. The granite countertops are stunning and the installation was flawless. Highly recommended!',
    rating: 5,
  },
  {
    name: 'Architect James Reyes',
    role: 'JR Design Studio',
    content:
      "We've partnered with LRJA on multiple commercial projects. Their consistency, quality, and professionalism are unmatched.",
    rating: 5,
  },
  {
    name: 'Chen Wei Lin',
    role: 'Restaurant Owner',
    content:
      'The bar counter they installed has become a centerpiece of our establishment. Guests always compliment the beautiful stone work.',
    rating: 5,
  },
];

export const whyChooseKeyPoints = [
  '10+ years of industry expertise',
  'Direct material sourcing',
  'Lifetime warranty on installations',
  'Free consultation and estimates',
];

export const portfolioCategories = [
  { id: 'all', name: 'All Works' },
  { id: 'kitchen', name: 'Kitchen Countertops' },
  { id: 'bathroom', name: 'Bathroom Countertops' },
  { id: 'bar', name: 'Bar Counters' },
  { id: 'tables', name: 'Tables' },
  { id: 'wall', name: 'Wall Cladding' },
  { id: 'reception', name: 'Reception Worktops' },
];

export const portfolioItems = [
  {
    id: 1,
    category: 'reception',
    title: 'Hotel Reception Countertop',
    description: 'A sleek, high-impact granite reception surface crafted to welcome guests with a refined first impression.',
    image: portfolioImage1,
    location: 'AC Hotel by Marriott Manila, Pasig City',
  },
  {
    id: 2,
    category: 'bathroom',
    title: 'Bathroom Vanity Countertop',
    description: 'Premium marble-look granite vanity with an integrated sink layout, balancing elegance and daily durability.',
    image: portfolioImage5,
    location: 'Manila Marriott Hotel, Pasay City',
  },
  {
    id: 3,
    category: 'bar',
    title: 'Restaurant Bar Countertop',
    description: 'A sophisticated granite bar surface designed to complement ambient lighting and elevate the guest experience.',
    image: portfolioImage7,
    location: "Nono's, Opus Mall, Quezon City",
  },
  {
    id: 4,
    category: 'bar',
    title: 'Cafe Bar Countertop',
    description: 'A clean, contemporary coffee bar countertop built for high traffic while maintaining a premium visual finish.',
    image: portfolioImage9,
    location: "Toby's Estate, Power Plant Mall, Makati City",
  },
  {
    id: 5,
    category: 'reception',
    title: 'Corporate Reception Desk',
    description: 'Custom-fabricated granite reception top engineered for long-term durability and a polished corporate aesthetic.',
    image: portfolioImage8,
    location: 'Robinsons Equitable Tower, Pasig City',
  },
  {
    id: 6,
    category: 'reception',
    title: 'Mall Reception Counter',
    description: 'A bespoke granite reception counter delivering a strong visual identity with reliable day-to-day performance.',
    image: portfolioImage6,
    location: 'Mitsukoshi Mall, BGC, Taguig City',
  },
  {
    id: 7,
    category: 'reception',
    title: 'Executive Reception Counter',
    description: 'Precision-installed granite reception counter built to withstand heavy use while preserving a sleek, modern look.',
    image: portfolioImage2,
    location: 'Science Hub 2, McKinley Hill, Taguig City',
  },
  {
    id: 8,
    category: 'bar',
    title: 'High-End Bar Countertop',
    description: 'A striking granite bar counter installation tailored for prestige spaces, combining visual depth with lasting strength.',
    image: portfolioImage3,
    location: 'Malacañang Palace, Manila',
  },
  {
    id: 9,
    category: 'wall',
    title: 'Columbarium Wall Cladding',
    description: 'Elegant granite wall cladding designed for memorial spaces, offering timeless appearance and structural reliability.',
    image: portfolioImage4,
    location: 'Manila Memorial Park, Parañaque City',
  },
];